import React from "react";

import { Link } from "react-router-dom";

import "../App.css";

const PrivacyPolicy = () => {
  return (
    <div className="ac-container">
      <h2>PRIVACY POLICY</h2>
      <p>
        This privacy policy has been compiled to better serve those who are
        concerned with how their 'Personally Identifiable Information' (PPI) is
        being used online. PPI, as described in US privacy law and information
        security, is information that can be used on its own or with other
        information to identify, contact, or to identify an individual in
        context. Please read our privacy policy carefully to get a clear
        understanding of how we collect, use, protect, or otherwise handle your
        Personally Identifiable Information in accordance with our website.
      </p>
      <p>
        <strong>
          What personal information do we collect from the people that visit our
          website?
        </strong>
      </p>
      <p>We do not collect information from visitors of our site.</p>
      <p>
        <strong>Do we use "cookies"?</strong>
      </p>
      <p>
        We use cookies from Google Analytics to measure how users interact with
        this website's content.
      </p>
      <p>
        You can choose to have your computer warn you each time a cookie is
        being sent, or you can choose to turn off all cookies. You do this
        through your browser settings. Since each browser is a little different,
        look at your browser's Help Menu to learn the correct way to modify your
        cookies.
      </p>
      <p>
        If you turn cookies off, some features will be disabled that make your
        website experience more efficient and may not function properly.
      </p>
      <p>
        <strong>Third-party disclosure</strong>
      </p>
      <p>
        We do not sell, trade, or otherwise transfer to outside parties your
        Personally Identifiable Information unless we provide users with advance
        notice. This does not include website hosting partners and other parties
        who assist us in operating our website, conducting our business, or
        serving our users, so long as those parties agree to keep this
        information confidential. We may also release information when it's
        release is appropriate to comply with the law, enforce our site
        policies, or protect ours or others' rights, property, or safety.
      </p>
      <p>
        However, non-personally identifiable visitor information may be provided
        to other parties for marketing, advertising, or other uses.
      </p>
      <p>
        <strong>Third-party links</strong>
      </p>
      <p>
        Occasionally, at our discretion, we may include or offer third-party
        products or services on our website. These third-party sites have
        separate and independent privacy policies. We therefore have no
        responsibility or liability for the content and activities of these
        linked sites. Nonetheless, we seek to protect the integrity of our site
        and welcome any feedback about these sites.
      </p>
      <p>
        <strong>Google</strong>
      </p>
      <p>
        Google's advertising requirements can be summed up by Google's
        Advertising Principles. They are put in place to provide a positive
        experience for users. Visit <a
          href="https://support.google.com/adspolicy/answer/6008942?hl=en"
          target="_blank"
          rel="noopener noreferrer"
        >
          Google Adwords Policy
        </a>.
      </p>
      <p>We use Google AdSense Advertising on our website.</p>
      <p>
        Google, as a third-party vendor, uses cookies to serve advertisements on
        our website. Google's use of the DART cookie enables it to serve
        advertisements to our users based on previous visits to our website on
        the Internet. Users may opt-out of the use of the DART cookie by
        visiting the Google Ad and Content Network privacy policy.
      </p>
      <div>
        <strong>We have implemented the following:</strong>
        <br />
        <ul>
          <li>Remarketing with Google AdSense</li>
          <li>Google Display Network Impression Reporting</li>
          <li>Demographics and Interests Reporting</li>
          <li>DoubleClick Platform Integration</li>
        </ul>
      </div>
      <p>
        We, along with third-party vendors such as Google use first-party
        cookies (such as the Google Analytics cookies) and third-party cookies
        (such as the DoubleClick cookie) or other third-party identifiers
        together to compile data regarding user interactions with ad impressions
        and other ad service functions as they relate to our website.
      </p>
      <p>
        <strong>Opting out:</strong>
      </p>
      <p>
        Users can set preferences for how Google advertises to you using the
        Google Ad Settings page. Alternatively, you can opt out by visiting the
        Network Advertising Initiative Opt Out page or by using the Google
        Analytics Opt Out Browser add on.
      </p>
      <p>
        <strong>California Online Privacy Protection Act</strong>
      </p>
      <p><a
          href="https://consumercal.org/about-cfc/cfc-education-foundation/california-online-privacy-protection-act-caloppa-3/#sthash.0FdRbT51.dpuf"
          target="_blank"
          rel="noopener noreferrer"
        >CalOPPA</a> is the first state law in the nation to require commercial websites and
        online services to post a privacy policy. The law's reach stretches well
        beyond California to require any person or company in the United States
        (and conceivably the world) that operates websites collecting Personally
        Identifiable Information from California consumers to post a conspicuous
        privacy policy on its website stating exactly the information being
        collected and those individuals or companies with whom it is being
        shared.
      </p>
      <div>
        <strong>According to CalOPPA, we agree to the following:</strong>
        <ul>
          <li>Users can visit our website anonymously.</li>
          <li>
            Once this privacy policy is created, we will add a link to it on our
            home page or as a minimum, on the first significant page after
            entering our website.
          </li>
          <li>
            Our Privacy Policy link includes the word 'Privacy' and can be
            easily be found on every page.
          </li>
          <li>
            You will be notified of any Privacy Policy changes on our Privacy
            Policy page.
          </li>
        </ul>
      </div>
      <p>
        <strong>How does our website handle Do Not Track signals?</strong>
      </p>
      <p>
        We honor Do Not Track signals and Do Not Track, plant cookies, or use
        advertising when a Do Not Track (DNT) browser mechanism is in place.
      </p>
      <p>
        <strong>Does our website allow third-party behavioral tracking?</strong>
      </p>
      <p>
        It's also important to note that we allow third-party behavioral
        tracking.
      </p>
      <p>
        <strong>COPPA (Children Online Privacy Protection Act)</strong>
      </p>
      <p>
        When it comes to the collection of personal information from children
        under the age of 13 years old, the <a
          href="https://www.ftc.gov/enforcement/rules/rulemaking-regulatory-reform-proceedings/childrens-online-privacy-protection-rule"
          target="_blank"
          rel="noopener noreferrer"
        >Children's Online Privacy Protection Act (COPPA)</a> puts parents in 
        control. The Federal Trade Commission, United States'
        consumer protection agency, enforces the COPPA Rule, which spells out
        operators of websites and online services must do to protect children's
        privacy and safety online.
      </p>
      <p>
        We do not specifically market to children under the age of 13 years old.
      </p>
      <p>
        <strong>Fair Information Practices</strong>
      </p>
      <p>
        The Fair Information Practices Principles form the backbone of privacy
        law in the United States and the concepts they include have played a
        significant role in the development of data protection laws around the
        globe. Understanding the Fair Information Practice Principles and how
        they should be implemented is critical to comply with the various
        privacy laws that protect personal information.
      </p>
      <p>
        <strong>
          In order to be in line with Fair Information Practices we will take
          the following responsive action, should a data breach occur:
        </strong>
      </p>
      <p>We will notify the users via in-site notification</p>
      <div>
        <ul>
          <li>Within 1 business day</li>
        </ul>
      </div>
      <p>
        We also agree to the Individual Redress Principle which requires that
        individuals have the right to legally pursue enforceable rights against
        data collectors and processors who fail to adhere to the law. This
        principle requires not only that individuals have enforceable rights
        against data users, but also that individuals have recourse to courts or
        government agencies to investiage and/or prosecute non-compliance by
        data processors.
      </p>
      <p>
        <strong>CAN SPAM Act</strong>
      </p>
      <p>The <a
          href="https://www.ftc.gov/tips-advice/business-center/guidance/can-spam-act-compliance-guide-business"
          target="_blank"
          rel="noopener noreferrer"
        >CAN-SPAM Act</a> is a law that sets the rules for commercial email, establishes
        requirements for commercial messages, gives recipients the right to have
        emails stopped from being sent to them, and spells out tough penalties
        for violations.
      </p>
      <p>We do not collect your email address.</p>
      <p>
        <strong>
          General Data Protection Regulation (
          <a 
            href="https://gdpr.eu/what-is-gdpr/" 
            target="_blank"
            rel="noopener noreferrer"
          >
            GDPR
          </a>
          )
        </strong>
      </p>
      <p>We are a Data Controller of your information.</p>
      <p>
        Asciicode.ws' legal basis for collecting and using the personal
        information described in this Privacy Policy depends on the Personal
        Information we collect and the specific context in which we collect the
        information:
      </p>
      <div>
        <ul>
          <li>Asciicode.ws needs to perform a contract with you</li>
          <li>You have given Asciicode.ws permission to do so</li>
          <li>
            When processing your personal information is in Asciicode.ws'
            legitimate interest
          </li>
          <li>Asciicode.ws needs to comply with the law</li>
        </ul>
      </div>
      <p>
        Asciicode.ws will retain your personal information only for as long as
        is necessary for the purposes set out in the Privacy Policy. We will
        retain and use your information to the extent necessary to comply with
        our legal obligations, resolve disputes, and enforce our policies. If
        you are a resident of the European Economic Area (EEA), you have certain
        data protection rights. If you wish to be informed what Personal
        Information we hold about you and if you want it to be removed from our
        systems, please <Link to="contact">contact us</Link>.
      </p>
      <p>
        In certain circumstances, you have the following data protection rights:
      </p>
      <div>
        <ul>
          <li>
            The right to access, update, or to delete the information we have on
            you.
          </li>
          <li>The right of rectification.</li>
          <li>The right to object.</li>
          <li>The right of restriction.</li>
          <li>The right to data portability.</li>
          <li>The right to withdraw consent.</li>
        </ul>
      </div>
      <p>
        <strong>Log files</strong>
      </p>
      <p>
        Asciicode.ws follows a standard procedure of using log files. These
        files log visitors when they visit websites. All hosting companies do
        this and a part of hosting services' analytics. The information
        collected by log files include internet protocol (IP) addresses, browser
        type, Internet Service Provider (ISP), date and time stamp,
        referring/exit pages, and possibly the number of clicks. These are not
        linked to any information that is personally indentifiable. The purpose
        of the information is for analyzing trends, administering the site,
        tracking users' movement on the website, and gathering demographic
        information.
      </p>
      <p>
        <strong>Contacting us</strong>
      </p>
      <p>
        If there are any questions regarding this privacy policy, you may
        contact us using the <Link to="contact">Contact Us</Link> page.
      </p>
      <p>
        asciicode.ws
        <br />
        California
        <br />
        Last Edited on 2021-05-05
      </p>
    </div>
  );
};

export default PrivacyPolicy;
